export const CLEAR_ERROR = '[Error] Clear';
export type ErrorType =
  | 'authentication'
  | 'user'
  | 'seasonFights'
  | 'userSeason'
  | 'season';

export interface ClearErrorAction {
  type: typeof CLEAR_ERROR;
  payload: ErrorType;
}
